import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ReplaceIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 18v-3l3.984 3.984L12 23.015v-3c-4.406 0-8.016-3.609-8.016-8.016 0-1.547.469-3.047 1.266-4.266l1.453 1.453C6.234 10.03 6 10.967 6 11.999c0 3.328 2.672 6 6 6zm0-14.016c4.406 0 8.016 3.609 8.016 8.016a7.858 7.858 0 0 1-1.266 4.266l-1.453-1.453c.469-.844.703-1.781.703-2.813 0-3.328-2.672-6-6-6v3L8.016 5.016 12 .985v3z"/></svg>
        )
    }
}

export default withCssClassName(ReplaceIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/replace-icon.js